export const BOOKING_CANDIDATE_DECLINE_SUBMIT_REQUEST = 'booking-candidate/decline-submit-request'
export const BOOKING_CANDIDATE_DECLINE_SUBMIT_SUCCESS = 'booking-candidate/decline-submit-success'
export const BOOKING_CANDIDATE_DECLINE_SUBMIT_FAILED = 'booking-candidate/decline-submit-failed'
